import Div from 'src/components/atomic/atom/Div'
import Button from 'src/components/atomic/atom/Button'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'

import { commonUtils } from 'src/utils/common.utils'
import useDynamicWindowHeightHook from 'src/hooks/useDynamicWindowHeight.hook'

const HomeViewUserGuide = () => {
  const { t } = useTranslation()
  const { setMediaStyle, currentMedia } = useMediaQueryHook()
  const { windowHeight } = useDynamicWindowHeightHook()

  const HomeViewUserGuideStyle = {
    maxWidth: setMediaStyle('396px', '600px', '100%'),
    width: '100%',
    marginTop: setMediaStyle(windowHeight >= 945 ? 'auto' : '115px', '32px', '45px'),
    paddingBottom: '41px',
  }

  const ViewUserGuideClickFn = () => {
    commonUtils.OpenExternalPage(
      `https://www.mfinder.ai/${currentMedia === 'mobile' ? 'webview/help/guide' : 'help/guide'}`,
    )
  }

  return (
    <Div onClick={ViewUserGuideClickFn} style={HomeViewUserGuideStyle}>
      <Button
        option={'bigIconText'}
        $margin={setMediaStyle('0', '0', '0 0 14px 0')}
        className={'menu_userguide'}
      >
        <Svg name={'view_user_guide_icon'} $margin={'0 13px 0 0'} />
        <Span option={'medium_bold'} display={'flex'} $text_align={'left'}>
          {t('HOME.GO_GUIDE', { defaultValue: 'View user guide' })}
        </Span>
        <Svg name={'arrow'} />
      </Button>
    </Div>
  )
}
export default HomeViewUserGuide
